export const getExpenseCategoryMaintenanceFields = (
  isLoading,
  expcategorystate,
  setExpCategoryState,
) => {
  return [
    {
      type: 'textarea',
      name: 'categoryDesc',
      placeholder: 'Description',
      label: 'Description',
      autofocus: false,
      required: true,
      disabled: isLoading,
      value: expcategorystate.categoryDesc,
      setValue: (e) => {
        const value = e.target.value;
        setExpCategoryState({ ...expcategorystate, categoryDesc: value });
      },
    },
    {
      type: 'dropdown',
      name: 'is_add_ons',
      placeholder: 'Select type',
      label: 'Type',
      required: true,
      disabled: isLoading,
      value: expcategorystate.is_add_ons,
      dropdownOptions: [
        {id: '0', description: 'Expense'},
        {id: '1', description: 'Add Ons'},
      ],
      setValue: (value, option) => {
        setExpCategoryState({
          ...expcategorystate,
          is_add_ons: value ,
        });
      },
    },
  ];
};
